import React from "react";
import PropTypes from "prop-types";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { useTheme } from "@material-ui/core/styles";

import Footer from "../components/footer/Footer";

const DialogLayout = ({ children }) => {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("xs"));

  return (
    <div>
      <Dialog
        fullScreen={fullScreen}
        disableBackdropClick
        disableEscapeKeyDown
        open
        fullWidth
        maxWidth="sm"
        scroll="body"
        BackdropProps={{
          style: { backgroundColor: theme.palette.background.default }
        }}
      >
        <DialogContent style={{ minHeight: "500px", padding: "0" }}>
          {children}
        </DialogContent>
      </Dialog>
      <Footer />
    </div>
  );
};

DialogLayout.propTypes = {
  children: PropTypes.node.isRequired
};

export default DialogLayout;
